import React from "react";
import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import { parseDate } from "chrono-node";
import escapeName from "../../utils/escape-form-name";

const rome = process.browser && require("rome");

import { DATE_FORMATS } from "../../constants";

const { DATE_PICKER_FORMAT } = DATE_FORMATS;

class DateInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.positionCalendar = this.positionCalendar.bind(this);
    this.textInput = null;
    this.setTextInputRef = (element) => {
      this.textInput = element;
    };
  }

  toDatePickerFormat(date) {
    if (!date) return "";
    if (typeof date === "string") {
      return this.toDatePickerFormat(parseDate(date));
    }
    if (date instanceof Date && isFinite(date) && date) {
      date = moment(date);
    }
    if (typeof date.format === "function" && date.isValid()) {
      const startOfTime = moment(0);
      if (date.isSameOrBefore(startOfTime)) return "";
      return date.format(DATE_PICKER_FORMAT);
    }

    return "";
  }

  setOptions() {
    const weekStart = this.context.locals.activeUser.startingCalendarDay || 0;
    let opts = Object.assign({}, this.props, {
      weekStart,
    });
    if (this.rome) {
      this.rome.options(opts);
    } else {
      const prefs = Object.assign(_.clone(this.props), {
        styles: {
          container: _.get(this.props, "altPosition", false)
            ? "rd-container alt-position"
            : "rd-container",
        },
      });

      this.rome = rome(this.textInput, prefs);
    }

    const romeContainer = this.rome.associated.getBoundingClientRect();
    if (this.props.alignRight) {
      const rightFromLeft = romeContainer.right;
      this.rome.container.classList.add(`align-calendar-right`);
      this.rome.container.style.right = `calc(100vw - ${rightFromLeft}px)`;
    }

    this.rome.on("show", this.positionCalendar);
    if (this.props.onChange) {
      let ignore = false;
      this.date = this.rome.getDateString();
      this.rome.on("next", ignoreChange);
      this.rome.on("back", ignoreChange);
      this.rome.on("data", (data) => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if (!ignore && this.date !== data) {
            this.date = data;
            if (ignore) return (ignore = false);
            this.props.onChange(this.date);
          }
        });
      });
      this.rome.on("hide", () => {
        if (this.rome.getDateString() !== this.date) {
          this.date = this.rome.getDateString();
          this.props.onChange(this.date);
        }
      });
      function ignoreChange() {
        ignore = true;
      }
    }
  }

  handleKeyDown(e) {
    const { keyCode } = e;
    if (keyCode === 13) {
      this.handleInputBlur(e);
    }
  }

  handleInputBlur({ target }) {
    if (target.value !== this.rome.getDateString()) {
      this.rome.setValue(this.toDatePickerFormat(target.value));
      this.date = this.rome.getDateString();
    }
  }
  positionCalendar() {
    const romeContainer = this.rome?.container.getBoundingClientRect();
    const associated = this.rome?.associated.getBoundingClientRect();

    if (!romeContainer) return;

    const overFlowBottom = romeContainer.bottom - window.innerHeight;

    if (overFlowBottom > 0) {
      this.rome.container.classList.add(`position-top`);
      this.rome.container.style.bottom = `calc(100vh - ${associated.top}px + 0.5rem`;
    }
  }

  componentDidMount() {
    this.setOptions();
    window.addEventListener("resize", this.positionCalendar);
  }
  componentDidUpdate() {
    this.setOptions();
  }
  componentWillUnmount() {
    _.invoke(this.rome, "destroy");
  }
  componentWillReceiveProps(next) {
    const prevValue = this.toDatePickerFormat(this.props.value);
    const nextValue = this.toDatePickerFormat(next.value);
    if (prevValue !== nextValue) {
      this.textInput.value = nextValue;
      this.handleInputBlur({ target: this.textInput });
    }
  }

  render() {
    const {
      name,
      customClassNames = "",
      datePlaceholder,
      isDisabled = false,
    } = this.props;
    const currentValue = this.props.value || this.props.defaultValue || "";
    const defaultValue = this.toDatePickerFormat(currentValue);

    return (
      <div
        role="date-selector-wrapper"
        style={this.props.smallSize ? { width: "145px" } : {}}
      >
        <input
          key={name}
          // ref="input"
          ref={this.setTextInputRef}
          type="text"
          style={
            this.props.dontPadding
              ? { marginBottom: "0px" }
              : this.props.smallSize
              ? { color: "#B9B9B9" }
              : {}
          }
          className={`${customClassNames} text-input`}
          autoComplete="off"
          readOnly
          onBlur={this.handleInputBlur}
          onKeyDown={this.handleKeyDown}
          {..._.omit(
            this.props,
            _.keys(DateInput.defaultProps).concat(
              "value",
              "max",
              "min",
              "dateValidator"
            )
          )}
          onChange={this.props.forceOnChange ? this.props.onChange : _.noop}
          defaultValue={defaultValue}
          placeholder={datePlaceholder || "Select Date"}
          disabled={isDisabled}
        />

        <input type="hidden" name="_dates[]" value={escapeName(name)} />
        <img src={"/img/svg/angle-down.svg"} />
      </div>
    );
  }
}

DateInput.defaultProps = {
  altPosition: false,
  autoClose: true,
  autoHideOnBlur: true,
  autoHideOnClick: true,
  date: true,
  time: false,
  dayFormat: "D",
  monthFormat: "MMMM YYYY",
  inputFormat: DATE_PICKER_FORMAT,
  //   weekdayFormat: ["S", "M", "T", "W", "T", "F", "S"],
  weekdayFormat: "short",
  monthsInCalendar: 1,
  dontPadding: false,
};

DateInput.contextTypes = { locals: PropTypes.object };

export default DateInput;
